import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ArrowRightIcon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 sm:py-32 px-4 bg-carbon-950 border-t border-carbon-800 relative" data-id="element-143">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-electric/5 rounded-full blur-[150px] pointer-events-none" data-id="element-144" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-145">
        <FadeIn delay={0.1} data-id="element-146">
          <div className="bg-carbon-900 border border-electric p-8 sm:p-12 relative shadow-2xl shadow-electric/10 rounded-3xl" data-id="element-147">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-electric text-carbon-950 font-mono text-xs font-bold px-4 py-1.5 uppercase tracking-widest rounded-full" data-id="element-148">
              Precio de lanzamiento
            </div>

            <div className="text-center mb-10 mt-4" data-id="element-149">
              <h3 className="text-3xl sm:text-4xl font-display text-white mb-4 uppercase tracking-wide" data-id="element-150">
                MÉTODO HYBRID 360
                <br data-id="element-151" />
                <span className="text-electric" data-id="element-152">SISTEMA COMPLETO</span>
              </h3>
              <p className="text-carbon-400 font-sans" data-id="element-153">
                El sistema integral para desarrollar fuerza, resistencia y
                composición corporal sin sacrificar ninguna.
              </p>
            </div>

            <div className="bg-carbon-950 border border-carbon-800 p-6 mb-10 rounded-2xl" data-id="element-154">
              <ul className="space-y-4 font-sans text-sm sm:text-base text-carbon-300" data-id="element-155">
                {['Tomo 1 — Fundamentos del Método Hybrid 360', 'Tomo 2 — Capacidades Físicas del Atleta Híbrido', 'Tomo 3 — Programación y Periodización', 'Tomo 4 — Nutrición, Recuperación y Prevención', 'Tomo 5 — Escudo Inmunológico', 'Tomo 6 — Identidad Híbrida', 'Bono 1 — Mapa de Inicio Hybrid 360', 'Bono 2 — Checklist Pre-Entreno', 'Bono 3 — Menú Express del Atleta Híbrido', 'Bono 4 — Diario Semanal de Progreso', 'Bono 5 — Reset Híbrido de 7 Días', 'Acceso inmediato y descarga permanente'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                    <span className="font-mono text-electric mt-0.5" data-id="element-157">✓</span>
                    <span className={i === 11 ? 'text-white font-semibold' : ''} data-id="element-158">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center mb-10" data-id="element-159">
              <p className="text-carbon-400 font-mono text-xs uppercase tracking-widest mb-2" data-id="element-160">
                Precio de lanzamiento:
              </p>
              <div className="text-6xl sm:text-8xl font-display text-electric leading-none tracking-tight" data-id="element-161">
                $16.990{' '}
                <span className="text-3xl sm:text-4xl text-carbon-500" data-id="element-162">
                  ARS
                </span>
              </div>
              <p className="text-carbon-500 font-sans text-sm mt-4" data-id="element-163">
                Acceso inmediato — Descarga permanente
              </p>
            </div>

            <a href="https://entrenamiento-hybridos.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full bg-electric hover:bg-electric-hover text-carbon-950 px-8 py-5 rounded-2xl flex flex-col items-center justify-center transition-all group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric focus-visible:ring-offset-2 focus-visible:ring-offset-carbon-900" data-id="element-164">
              <span className="flex items-center gap-3 font-display text-2xl sm:text-3xl tracking-wide uppercase" data-id="element-165">
                QUIERO EL MÉTODO AHORA
                <ArrowRightIcon className="w-6 h-6 sm:w-8 sm:h-8 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-166" />
              </span>
              <span className="font-mono text-xs sm:text-sm font-semibold tracking-widest mt-1 opacity-80 uppercase" data-id="element-167">
                Acceso inmediato al sistema completo
              </span>
            </a>

            <TrustBadges data-id="element-168" />
          </div>
        </FadeIn>
      </div>
    </section>;
}